var _mask, _path, _path2, _mask2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2734_27223",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0127 0L0.139893 4.2548V16.4874L2.13876 15.5288V5.93548L9.0127 2.53356V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0127 0L0.139893 4.2548V16.4874L2.13876 15.5288V5.93548L9.0127 2.53356V0Z",
    fill: "#FD9879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.139893 4.2548L-0.724885 2.45143L-1.86011 2.99581V4.2548H0.139893ZM9.0127 0H11.0127V-3.17713L8.14792 -1.80337L9.0127 0ZM0.139893 16.4874H-1.86011V19.6645L1.00467 18.2907L0.139893 16.4874ZM2.13876 15.5288L3.00354 17.3322L4.13876 16.7878V15.5288H2.13876ZM2.13876 5.93548L1.25165 4.14299L0.138765 4.69376V5.93548H2.13876ZM9.0127 2.53356L9.89981 4.32605L11.0127 3.77528V2.53356H9.0127ZM1.00467 6.05818L9.87747 1.80337L8.14792 -1.80337L-0.724885 2.45143L1.00467 6.05818ZM2.13989 16.4874V4.2548H-1.86011V16.4874H2.13989ZM1.27399 13.7255L-0.724885 14.684L1.00467 18.2907L3.00354 17.3322L1.27399 13.7255ZM4.13876 15.5288V5.93548H0.138765V15.5288H4.13876ZM3.02588 7.72798L9.89981 4.32605L8.12559 0.741061L1.25165 4.14299L3.02588 7.72798ZM7.0127 0V2.53356H11.0127V0H7.0127Z",
    fill: "#FD9879",
    mask: "url(#path-1-inside-1_2734_27223)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2734_27223",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5842 3.25586L3.71143 7.51066V19.7432L6.13657 18.5803V9.41935L12.5842 6.241V3.25586Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5842 3.25586L3.71143 7.51066V19.7432L6.13657 18.5803V9.41935L12.5842 6.241V3.25586Z",
    fill: "#9E523B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71143 7.51066L2.84665 5.70729L1.71143 6.25167V7.51066H3.71143ZM12.5842 3.25586H14.5842V0.0787289L11.7195 1.45248L12.5842 3.25586ZM3.71143 19.7432H1.71143V22.9204L4.5762 21.5466L3.71143 19.7432ZM6.13657 18.5803L7.00135 20.3837L8.13657 19.8393V18.5803H6.13657ZM6.13657 9.41935L5.25228 7.62547L4.13657 8.17545V9.41935H6.13657ZM12.5842 6.241L13.4685 8.03489L14.5842 7.4849V6.241H12.5842ZM4.5762 9.31404L13.449 5.05923L11.7195 1.45248L2.84665 5.70729L4.5762 9.31404ZM5.71143 19.7432V7.51066H1.71143V19.7432H5.71143ZM5.27179 16.7769L2.84665 17.9398L4.5762 21.5466L7.00135 20.3837L5.27179 16.7769ZM8.13657 18.5803V9.41935H4.13657V18.5803H8.13657ZM7.02086 11.2132L13.4685 8.03489L11.6999 4.44712L5.25228 7.62547L7.02086 11.2132ZM10.5842 3.25586V6.241H14.5842V3.25586H10.5842Z",
    fill: "#9E523B",
    mask: "url(#path-3-inside-2_2734_27223)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28223 21.4105V11.396L15.155 8.10028V18.1148L8.28223 21.4105Z",
    fill: "#FD9879",
    stroke: "#FD9879",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.e1ae81ec1d539c10415c0d92c826a0ae.svg";
export { ForwardRef as ReactComponent };